export function DemoBanner() {
  return (
    <div className="w-full bg-atlas-brass dark:bg-atlas-brass-dark text-atlas-ink text-center text-sm font-semibold py-2 px-4 tracking-wide">
      DEMO MODE — Computer players are active
    </div>
  );
}
